// extracted by mini-css-extract-plugin
export var actions = "_k5-g";
export var benefitCard = "_k5-b";
export var benefitIcon = "_k5-d";
export var benefitLabel = "_k5-f";
export var benefits = "_k5-a";
export var benefitsSection = "_k5-8";
export var bodyText = "_k5-7";
export var closeButton = "_k5-2";
export var content = "_k5-3";
export var eyebrow = "_k5-4";
export var heading = "_k5-5";
export var image = "_k5-i";
export var imagePanel = "_k5-h";
export var modal = "_k5-0";
export var offerCard = "_k5-c";
export var offerIcon = "_k5-e";
export var sectionLabel = "_k5-9";
export var shell = "_k5-1";
export var title = "_k5-6";